import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=60b68f26&scoped=true"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"
import style0 from "../assets/css/statistics.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Statistics.vue?vue&type=style&index=1&id=60b68f26&prod&lang=scss"
import style2 from "./Statistics.vue?vue&type=style&index=2&id=60b68f26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b68f26",
  null
  
)

export default component.exports